<script lang="ts">
  import { onMount } from "svelte";
  import { gaEventParams, sendGAEvent, isMobile } from "../../helpers";
  import {
    step,
    type,
    location,
    showBookingModal,
    book,
    bookLocation,
    resetBooking,
  } from "../../stores/BookingStore";

  import {
    locationsWithNewWalkins,
    locationsWithSocialLanes,
  } from "../../helpers/BookHelper";

  import {
    getBookingRate,
    getWeekdayTeamBuildingRate,
    setBookSessionStorage,
  } from "../../helpers/BookHelper";
  import Payment from "../Book/Payment/Payment.svelte";
  import SocialLanesPricing from "../SocialLanesSections/SocialLanesPricing.svelte";

  export let locationInformation: any;

  let locationEventDuration: string = "1.5 Hour Booking";
  let localWalkinDuration: string = "45 minutes";
  let locationTeamBuildingDuration: string = "2 Hour Booking";
  let walkinsRate: object = {
    student: `19.99 <sup class="text-black">/Person</sup>`,
    standard: `26.98 <sup class="text-black">/Person</sup>`,
    all: `36.98 <sup class="text-black">/Person</sup>`,
  };
  let walkinsDuration: object = {
    student: "45 minutes",
    standard: "45 minutes",
    all: "60 minutes",
  };

  let currentStep;

  let hatchetBigaxe = ["san francisco", "surrey", "windsor"];
  let hatchetKnives = ["fresno", "mississauga"];
  let locationName: string;

  step.subscribe((value) => {
    currentStep = value;
  });

  location.subscribe((value) => {
    locationName = value.name;
  });

  let walkinRate = "";
  let packageRate = "";
  let groupMinimum = 4;
  let eventDuration = "";
  let walkinDuration = "";

  $: packageRate = locationInformation.rates.normal;
  $: walkinRate = locationInformation.rates.walkin;

  // Handlers
  const onBookNowHandler = () => {
    let typeOption = "booking";

    // Reset booking always
    resetBooking();

    setTimeout(() => {
      step.update((n) => -1);
      type.update(() => typeOption);

      let storedBookProcess = sessionStorage.getItem("book_process");
      if (storedBookProcess) {
        const bookProcess = JSON.parse(storedBookProcess);
        bookProcess.step = 2;
        bookProcess.type = typeOption;
        bookProcess.showBookingModal = isMobile() ? true : false;
        setBookSessionStorage(bookProcess);
      }

      // gaEventParams("booking", "type", "booking");
      sendGAEvent("booking", "booking", "selected");
      gaEventParams("booking", {
        type: "booking",
        status: "selected",
        selected: true,
      });

      // Show booking modal for mobile
      if (isMobile()) {
        showBookingModal.update((value) => true);
      }
    }, 10);
  };

  const onBookTeamBuildingHandler = () => {
    let typeOption = "team-building";

    // Reset booking always
    resetBooking();

    step.update((n) => 2);
    type.update(() => typeOption);

    let storedBookProcess = sessionStorage.getItem("book_process");
    if (storedBookProcess) {
      const bookProcess = JSON.parse(storedBookProcess);
      bookProcess.step = 2;
      bookProcess.type = typeOption;
      bookProcess.showBookingModal = isMobile() ? true : false;
      setBookSessionStorage(bookProcess);
    }

    sendGAEvent("booking", "team-building", "selected");
    gaEventParams("booking", {
      type: "team-building",
      status: "selected",
      selected: true,
    });

    // Show booking modal for mobile
    if (isMobile()) {
      showBookingModal.update((value) => true);
    }

    setTimeout(() => {
      step.update((n) => 2);
      type.update(() => typeOption);

      let storedBookProcess = sessionStorage.getItem("book_process");
      if (storedBookProcess) {
        const bookProcess = JSON.parse(storedBookProcess);
        bookProcess.step = 2;
        bookProcess.type = typeOption;
        bookProcess.showBookingModal = isMobile() ? true : false;
        setBookSessionStorage(bookProcess);
      }

      sendGAEvent("booking", "team-building", "selected");
      gaEventParams("booking", {
        type: "team-building",
        status: "selected",
        selected: true,
      });
    }, 10);
  };

  const getType = () => {
    if (hatchetBigaxe.includes(locationName.toLowerCase())) {
      return "Hatchet";
    } else if (hatchetKnives.includes(locationName.toLowerCase())) {
      return "Hatchet OR Knife";
    } else {
      return "Hatchet OR Knife";
    }
  };

  const getTypeAll = () => {
    if (hatchetBigaxe.includes(locationName.toLowerCase())) {
      return "Hatchet & Big Axe";
    } else if (hatchetKnives.includes(locationName.toLowerCase())) {
      return "Hatchet & Knife";
    } else {
      return "Hatchet | Knife | Big Axe";
    }
  };

  const getWalkinRate = (type: string) => {
    // Check the student type
    let student = 19.99;
    let standard = 26.98;
    let all = 36.98;

    // Windsor
    if (locationName.toLowerCase() === "windsor") {
      student = 19.99;
      standard = 25.98;
      all = 36.98;
    }

    if (locationsWithNewWalkins.includes(locationName.toLowerCase())) {
      student = 27.75;
      standard = 19.99;
      all = 36.99;
    }

    // // Alexandria
    // if (locationName.toLowerCase() === "alexandria") {
    //     student = 27.75;
    //     standard = 19.99;
    //     all = 36.99;
    // }

    // // Charlotte
    // if (locationName.toLowerCase() === "charlotte") {
    //     student = 27.75;
    //     standard = 19.99;
    //     all = 36.99;
    // }

    // if (locationName.toLowerCase() === "colorado springs") {
    //     student = 27.75;
    //     standard = 19.99;
    //     all = 36.99;
    // }
  };

  onMount(() => {
    // const bookEvent = new CustomEvent("bookProcessEvent", {
    //     detail: { step: 1 },
    // });
    // window.dispatchEvent(bookEvent);
    // sessionStorage.setItem(
    //     "book_process",
    //     JSON.stringify({
    //         step: 1,
    //         type: null,
    //     }),
    // );
    setBookSessionStorage({
      step: 1,
      type: null,
      showBookingModal: false,
    });

    if (locationName.toLowerCase() === "windsor") {
      locationEventDuration = "2 Hour Event";
      localWalkinDuration = "1 hour";
      locationTeamBuildingDuration = "2 Hour Event";
      walkinsRate = {
        student: 19.99,
        standard: 25.98,
        all: 36.98,
      };
      walkinsDuration = {
        student: "60 minutes",
        standard: "60 minutes",
        all: "75 minutes",
      };
    } else if (locationsWithNewWalkins.includes(locationName.toLowerCase())) {
      walkinsDuration = {
        student: "60 minutes",
        standard: "30 minutes",
        all: "60 minutes",
      };
      walkinsRate = {
        student: 27.75,
        standard: 19.99,
        all: 36.99,
      };
    } else {
      locationEventDuration = "1.5 Hour Booking";
      localWalkinDuration = "45 minutes";
      locationTeamBuildingDuration = "2 Hour Booking";
      walkinsRate = {
        student: 19.99,
        standard: 26.98,
        all: 36.98,
      };
      walkinsDuration = {
        student: "45 minutes",
        standard: "45 minutes",
        all: "60 minutes",
      };
    }
  });
</script>

<div class="my-8 w-full sm:w-full mx-auto px-4 sm:px-0">
  <h3 class="text-3xl sm:text-4xl uppercase font-semibold my-2 text-left">
    {#if locationName.toLowerCase() === "atlanta" || locationName.toLowerCase() === "long beach" || locationName.toLowerCase() === "chicago"}
      Choose your Booking Type
    {:else}
      No-Hassle Pricing
    {/if}
  </h3>
  <div
    class="grid grid-cols-1 sm:grid-cols-3 grid-rows-3 sm:grid-rows-1 gap-6 justify-center items-start"
  >
    {#if locationsWithSocialLanes.includes(locationName.toLowerCase())}
      <SocialLanesPricing location={locationName} context="location" />
    {:else}
      <div
        class="px-2 py-4 sm:px-2 sm:py-4 text-center rounded-xl border-2 border-gray-400 shadow-lg shadow-gray-800 flex flex-col items-center justify-start h-section-pricing-mobile sm:h-section-pricing relative"
      >
        <h4 class="text-2xl uppercase font-semibold mt-3">Walk-ins</h4>
        <p class="mb-4 border-b-2 border-yellow-400">
          Not a Booking, Just Stop By!!
        </p>
        <div
          class={`grid grid-cols-3 grid-rows-1 sm:grid-cols-3 sm:grid-rows-1 gap-1 w-full align-center justify-start`}
        >
          {#if locationsWithNewWalkins.includes(locationName.toLowerCase())}
            <div class={`rounded-lg bg-gray-200 px-2 py-2`}>
              <p class="text-2sm font-semibold text-center">
                Standard <span class="block text-5sm font-regular"
                  >{getType()}</span
                >
              </p>
              <p class="text-2sm text-center my-2 font-semibold">
                {walkinsDuration.standard}
              </p>
              <p class="text-2sm font-semibold text-brand text-center">
                ${walkinsRate.standard}
                <sup class="text-black">/Person</sup>
              </p>
            </div>
            <div class={`rounded-lg bg-gray-200 px-2 py-2`}>
              <p class="text-2sm font-semibold text-center">
                Student Rate <span class="block text-5sm font-regular"
                  >{getTypeAll()}</span
                >
              </p>
              <p class="text-2sm text-center my-2 font-semibold">
                {walkinsDuration.student}
              </p>
              <p class="text-2sm font-semibold text-brand text-center">
                ${walkinsRate.student}<sup class="text-black">/Student</sup>
              </p>
            </div>
          {:else}
            <div class={`rounded-lg bg-gray-200 px-2 py-2`}>
              <p class="text-2sm font-semibold text-center">
                Student Rate <span class="block text-5sm font-regular"
                  >{getTypeAll()}</span
                >
              </p>
              <p class="text-2sm text-center my-2 font-semibold">
                {walkinsDuration.student}
              </p>
              <p class="text-2sm font-semibold text-brand text-center">
                ${walkinsRate.student}<sup class="text-black">/Student</sup>
              </p>
            </div>
            <div class={`rounded-lg bg-gray-200 px-2 py-2`}>
              <p class="text-2sm font-semibold text-center">
                Standard <span class="block text-5sm font-regular"
                  >{getTypeAll()}</span
                >
              </p>
              <p class="text-2sm text-center my-2 font-semibold">
                {walkinsDuration.standard}
              </p>
              <p class="text-2sm font-semibold text-brand text-center">
                ${walkinsRate.standard}
                <sup class="text-black">/Person</sup>
              </p>
            </div>
          {/if}
          <div class={`rounded-lg bg-gray-200 px-2 py-2`}>
            <p class="text-2sm font-semibold text-center">
              Throw 'em All!<span class="block text-5sm font-regular"
                >{getTypeAll()}</span
              >
            </p>
            <p class="text-2sm text-center my-2 font-semibold">
              {walkinsDuration.all}
            </p>
            <p class="text-2sm font-semibold text-brand text-center">
              ${walkinsRate.all} <sup class="text-black">/Person</sup>
            </p>
          </div>
        </div>
        <p class="mt-4">Perfect for small groups!</p>
        <p>Walk-in hours posted above.</p>
        <p class="text-xs pt-2">
          *Must present valid Student ID on site to get student rate.
        </p>
      </div>
    {/if}

    <div
      class="relative px-4 py-4 sm:px-4 sm:py-4 text-center bg-brand rounded-xl border-2 border-brand text-white shadow-lg shadow-gray-800 flex flex-col items-center justify-start h-section-pricing-mobile sm:h-section-pricing mt-4 sm:mt-0"
    >
      <h4 class="text-2xl uppercase font-semibold text-white mt-3">
        Bad Axe Booking
      </h4>
      <p class="mb-3 inline-block text-white border-b-2 border-yellow-400">
        Dedicated Lanes. Guaranteed Time.
      </p>
      <p class="text-center">
        <span class="text-xs text-white">As low as</span>
        <span class="uppercase text-white text-4xl block font-semibold">
          {@html getBookingRate(locationName)}
        </span>
        <span class="block text-sm">{locationEventDuration}</span>
      </p>

      <p class="mt-4">Private Lanes. Expert Coach.</p>
      {#if locationName.toLowerCase() !== "winnipeg"}
        <p>Minimum of {groupMinimum} Payments.</p>
        <p>
          <span class="block mt-1 text-white text-xs"
            >*Prices vary depending on group size</span
          >
        </p>
      {/if}

      <a
        href="#new-booking"
        on:click={onBookNowHandler}
        class="bg-black uppercase text-white rounded-full px-8 pt-3 pb-2 mt-2 font-semibold w-48 absolute bottom-4"
        >Book Now</a
      >
    </div>

    <div
      class="px-4 py-4 sm:px-4 sm:py-4 text-center rounded-xl border-2 border-gray-400 shadow-lg shadow-gray-800 flex flex-col items-center justify-start h-section-pricing-mobile sm:h-section-pricing relative"
    >
      <h4 class="text-2xl uppercase font-semibold mt-3">
        {locationName.toLowerCase() === "windsor"
          ? "Weekday Team Building"
          : "Team Building"}
      </h4>
      <p class="inline-block border-b-2 border-yellow-400">
        {locationName.toLowerCase() === "windsor"
          ? "Mon-Fri, 8:30AM-1:30PM Start Times"
          : "Any Day, 8AM-8PM Start Times"}
      </p>
      <p class="text-center mt-2">
        {#if locationName.toLowerCase() !== "winnipeg"}
          <span class="text-xs mt-4 mb-2">As low as</span>
        {/if}
        <span
          class="uppercase text-4xl block font-semibold text-brand relative"
        >
          {@html getWeekdayTeamBuildingRate(locationName)}
        </span>
        <span class="block text-sm">{locationTeamBuildingDuration}</span>
        {#if locationName.toLowerCase() === "winnipeg"}
          <span class="block text-sm">2 Lanes</span>
        {/if}
      </p>
      <p class="text-base mt-6">Specialized Team-Building</p>
      <p class="text-base">Games and Tournaments</p>
      <a
        href="#new-booking"
        on:click={onBookTeamBuildingHandler}
        class="bg-brand text-white transition ease-in-out hover:bg-red-600 hover:text-white hover:border-white uppercase rounded-full px-8 pt-3 pb-2 mt-4 font-semibold absolute bottom-2 w-48 absolute bottom-4"
        >Book Now</a
      >
    </div>
  </div>
</div>

<style></style>
